// extracted by css-extract-rspack-plugin
export default {"number":"Dxo72PQMq4EugZMw"};